import styled from "styled-components";

export const RedBar = styled.h3`
  font-size: ${({ theme }) => theme.fontSize.m} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  background-color: ${({ theme }) => theme.colors.red} !important;
  font-family: JetBrains Mono;
  text-align: center !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal !important;
  max-width: 790px;
  width: 100%;
  padding: 15px !important;
  margin: 0;
`;
